




"use strict";

import PageHeader from './components/page-header';
import PageBackButton from './components/page-back-button';
import SideBar from './components/sidebar';
import KetelKiezer from './components/ketelkiezer';

window.addEventListener('DOMContentLoaded', (event) => {

    new PageHeader();
    new PageBackButton(document.querySelector('.page-back'));
    new SideBar(document.querySelector(".sidebar-section"));
    new KetelKiezer(document.querySelector('.ketelkiezer-holder'));

});

document.querySelector('html').classList.remove('no-js');
document.querySelector('html').classList.add('js');








// Tag manager gravity forms
function isVisible(el) {
    if (!el) return;
    var style = window.getComputedStyle(el);
    return (style.display !== 'none')
}
window.addEventListener('DOMContentLoaded', () => {
    if ( isVisible(document.querySelector('#gform_11 #gform_page_11_2')) ) {
        dataLayer.push({ ecommerce: null });
        dataLayer.push(getTagManagerJson('begin_checkout'));
    } else if ( isVisible(document.querySelector('#gform_11 #gform_page_11_3')) ) {
        dataLayer.push({ ecommerce: null });
        dataLayer.push(getTagManagerJson('add_shipping_info'));
    } else if ( isVisible(document.querySelector('#gform_11 #gform_page_11_4')) ) {
        dataLayer.push({ ecommerce: null });
        dataLayer.push(getTagManagerJson('add_payment_info'));
    }
});



function isInstallatieZonderZorgen () {
    let zonderZorgen = false;
    const installatieRadio = document.querySelector('.installatie_radio input[type="radio"][value="Installatie ZonderZorgen"');
    if ( installatieRadio && installatieRadio.checked && installatieRadio.getAttribute('checked') === 'checked' ) {
        zonderZorgen = true;
    }

    return zonderZorgen;
}



function getCurrentProducts () {
    const boilers = Array.from(document.querySelectorAll('.offerte_sidebar .boiler'))
        .map(boiler => {
            const price = isInstallatieZonderZorgen()
                            ? boiler.querySelector('.cv_price_with_contract').value || ''
                            : boiler.querySelector('.cv_price_without_contract').value || '';

            return {
                id: boiler.dataset.boilerid,
                name: boiler.querySelector('.cv_name').innerHTML || '',
                price: price,
                brand: boiler.querySelector('.cv_brand').value || '',
                category: "CV-Ketels",
                quantity: 1
            }
        });

    const thermostaten = Array.from(document.querySelectorAll('.offerte_sidebar .boiler'))
        .map(boiler => {
            const thermostaat_name = boiler.querySelector('.thermo_name');
            if ( thermostaat_name && thermostaat_name.dataset.id ) {
                const thermostaat_price = boiler.querySelector('.thermo_price').innerHTML;

                return {
                    id: thermostaat_name.dataset.id,
                    item_id: thermostaat_name.dataset.id,
                    item_name: thermostaat_name.dataset.name || '',
                    price: thermostaat_price,
                    item_brand: thermostaat_name.dataset.brand || '',
                    item_category: "Thermostaten",
                    quantity: 1
                }
            }
        });

    return [...boilers, ...thermostaten].filter(item => item);
}

function getTagManagerJson (event = null) {
    if (!event) return;

    const products = getCurrentProducts();
    const price = products.reduce((total,current) =>
        total += parseInt(current.price) , 0);
    return {
        "event": event,
        "ecommerce": {
            "value": price,
            "currency": "EUR",
            "items": products
        }
    };
}





function responsiveSidebar (sidebar) {
    const addResponsiveSidebarClass =  () => {
        if (window.screen.availWidth < 1200) {
            sidebar.classList.add('small');
            sidebar.classList.add('bottom');
        } else {
            sidebar.classList.remove('small');
            sidebar.classList.remove('bottom');
        }
    }
    addResponsiveSidebarClass();
    window.addEventListener('resize', addResponsiveSidebarClass);

    sidebar.addEventListener('click', () => sidebar.classList.toggle('small'));
}


window.addEventListener('DOMContentLoaded', (event) => {
    if ( document.querySelector('.sidebar.offerte_sidebar') ) {
        responsiveSidebar(document.querySelector('.sidebar.offerte_sidebar'));
    }

    if ( document.querySelector('.sidebar.show_total') ) {
        responsiveSidebar(document.querySelector('.sidebar.show_total'));
    }

    if ( document.querySelector('.onderhoud-form-holder aside.overzicht') ) {
        responsiveSidebar(document.querySelector('.onderhoud-form-holder aside.overzicht'));
    }
});
